import { render, staticRenderFns } from "./FlaggedIcon.vue?vue&type=template&id=adc2d2ce"
import script from "./FlaggedIcon.vue?vue&type=script&lang=js"
export * from "./FlaggedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports